import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Toolbar, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import c from 'classnames';

import './_subNavbar.scss';
import { routes } from '../../../../pages';

const SubNavbar = ({ children, route, replace }) => {
  const history = useHistory();
  const subClass = c('sub-content', { 'wider': !children });
  const backClass = c('back-route', { 'replace': replace });

  return (
    <Toolbar className="mobile-nav" classes={{ regular: 'regular-toolbar' }}>
      <div className={subClass}>
        <div className={backClass}>
          {!replace &&
            <>
              <IconButton onClick={() => history.length > 1 ? history.goBack() : history.push(routes.root.path)} edge="start" className="menu-button" color="inherit">
                <ChevronLeftIcon />
              </IconButton>
              <Typography>{route}</Typography>
            </>
          }
        </div>
        {children}
      </div>
    </Toolbar>
  );
};

SubNavbar.propTypes = {
  route: PropTypes.string.isRequired,
  children: PropTypes.node,
  replace: PropTypes.bool
};

export default SubNavbar;